import styled from "styled-components/macro"
import Color from "../../../constants/Color"
import { Link } from "react-router-dom"

export const HeaderMain = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  /* background: ${Color.gray200}; */
  background: #ffffff;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 0px 24px 32px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
  z-index: 444;
`

export const Wrapper = styled.div`
  width: 100%;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: 8px 0;
  }
`
export const Logo = styled.div`
  width: 84px;
  height: 39.4px;
  @media (min-width: 1024px) {
    width: 96px;
    height: 45.0333px;
  }
`
export const Image = styled.img`
  width: 100%;
  height: 100%;
`

export const SearchContainer = styled.div`
  @media (min-width: 640px) {
    display: flex;
    align-items: center;
  }
`
export const SearchBox = styled.div`
  display: none;

  @media (min-width: 640px) {
    width: 360px;
    display: block;
    position: relative;
    display: flex;
    align-items: center;
  }

  @media (min-width: 768px) {
    width: 400px;
  }

  @media (min-width: 1024px) {
    width: 560px;
  }
`

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 16px;
  color: ${Color.gray600};
  /* background: ${Color.gray200}; */
  background: #fafafa;
  border: 1px solid ${Color.gray300};
  border-radius: 4px;
  outline: none;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    font-size: 16px;
    padding: 10px 16px;
  }
`

export const SearchIcon = styled.i`
  position: absolute;
  font-size: 20px;
  color: ${Color.gray600};
  right: 12px;
  cursor: pointer;

  @media (min-width: 1024px) {
    font-size: 24px;
  }
`

export const Nav = styled.div`
  display: flex;
  align-items: center;

  & i {
    cursor: pointer;
    margin-left: 6px;
    font-size: 22px;
  }
`
export const NavLink = styled(Link)`
  font-size: 15px;
  display: flex;
  align-items: center;
  color: ${Color.gray500};
  text-decoration: none;
  padding: 0 2px;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: ${Color.gray600};
  }

  @media (min-width: 1280px) {
    font-size: 18px;
  }

  & i {
    font-size: 18px;
    color: ${Color.gray400};
    margin-right: 4px;
    transition: color 0.3s ease-in-out;
  }

  &:hover i {
    color: ${Color.primary};
  }
`
